module.exports = __webpack_public_path__ + "static/media/24_B.28a86015.png";